import { Flex } from '@repo/ui/Flex';
import { Icon } from '@repo/ui/Icon';

import { useSafePermissions } from '../../providers/permissions/usePermissions';
import s from './AgentModeBanner.module.css';

/**
 * Banner displayed when the app is running in agent mode.
 * Only visible when ?agent=true query parameter is set.
 * Returns null when not in agent mode.
 */
export const AgentModeBanner = () => {
  const permissions = useSafePermissions();

  if (!permissions?.isAgent) {
    return null;
  }

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      gap="g-8"
      padding="p-12"
      className={s.banner}
    >
      <Icon name="user" size="font" />
      <span className={s.text}>Agent Mode</span>
    </Flex>
  );
};
